import * as types from "./types";
import service from "../services";

export default {
  async [types.USE_FETCH]({ commit }, data = null) {
    commit(types.USE_SET_LOADING, true);
    const response = await service.fetch(data);
    commit(types.USE_OBTAIN, response.data.data);
    commit(types.USE_META, response.data.meta);
    commit(types.USE_SET_LOADING, false);
  },
  async [types.USE_FETCH_OPTION]({ commit }, data = null) {
    commit(types.USE_SET_LOADING, true);
    const response = await service.fetch(data);
    commit(types.USE_OBTAIN_OPTION, response.data.data);
    commit(types.USE_SET_LOADING, false);
  },
  async [types.USE_FIND]({ commit, state }, id = null) {
    if (!state.itemsDetail[id]) {
      commit(types.USE_SET_LOADING, true);
      const response = await service.fetch({ id: id });
      const item = response.data.data.find(function (id) {
        return (item) => item.id == id;
      });
      if (item) {
        commit(types.USE_OBTAIN_DETAIL, item);
      }
      commit(types.USE_SET_LOADING, false);
    }
  },
};
